import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AdhvaMonthlyCurrentAffairsPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div style={{
      fontFamily: "'Poppins', sans-serif",
      backgroundColor: '#111827',
      color: 'white',
      minHeight: '100vh',
      position: 'relative',
      backgroundImage: 'url("https://images.unsplash.com/photo-1585829365295-ab7cd400c167?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}>

      <Navbar />

      {/* Main Content Wrapper with Overlay */}
      <div style={{
        position: 'relative',
        zIndex: 1
      }}>
        {/* Grey Overlay - covers main content but not footer */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(17, 24, 39, 0.75)',
          zIndex: 0,
          pointerEvents: 'none'
        }}></div>

        {/* Top Bar */}
      <div style={{
        backgroundColor: '#eab308',
        color: '#111827',
        textAlign: 'center',
        padding: '0.5rem 1rem',
        fontWeight: 700,
        fontSize: '0.875rem',
        letterSpacing: '0.05em',
        position: 'relative',
        zIndex: 10
      }}>
        🚀 ADHVA ACADEMY PRESENTS
      </div>

      {/* Hero Section */}
      <header style={{
        position: 'relative',
        paddingTop: '4rem',
        paddingBottom: '5rem',
        padding: '4rem 1.5rem 5rem',
        zIndex: 10
      }}>
        <div style={{
          maxWidth: '896px',
          margin: '0 auto',
          textAlign: 'center',
          position: 'relative',
          zIndex: 10
        }}>
          <h1 style={{
            fontSize: 'clamp(1.5rem, 5vw, 3.75rem)',
            fontWeight: 800,
            lineHeight: 1.2,
            marginBottom: '1.5rem',
            color: 'white'
          }}>
            Master UPSC Current Affairs <br />
            <span style={{
              color: 'white',
              fontSize: 'clamp(1.125rem, 3vw, 2.25rem)',
              fontWeight: 600,
              display: 'block',
              marginTop: '1rem'
            }}>
              🛑 Stop worrying and start testing!
            </span>
          </h1>

          <div style={{
            width: '96px',
            height: '4px',
            backgroundColor: '#eab308',
            margin: '2rem auto',
            borderRadius: '9999px'
          }}></div>

          <p style={{
            fontSize: 'clamp(1.125rem, 2vw, 1.5rem)',
            color: 'white',
            fontWeight: 300,
            marginBottom: '2rem',
            maxWidth: '672px',
            margin: '0 auto 2rem'
          }}>
            Adhva Academy is here for serious <strong style={{ color: 'white' }}>UPSC CSE & Other Govt Exam Aspirants</strong> with our
          </p>

          <div style={{
            backgroundColor: 'rgba(31, 41, 55, 0.8)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(55, 65, 81, 1)',
            borderRadius: '1.5rem',
            padding: '2rem',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            display: 'inline-block',
            width: '100%',
            maxWidth: 'auto',
            transition: 'transform 0.3s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
          onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
            <h2 style={{
              fontSize: 'clamp(3rem, 7vw, 4.5rem)',
              fontWeight: 800,
              background: 'linear-gradient(to right, #facc15, #fef08a)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: '0.5rem'
            }}>
              FREE
            </h2>
            <h3 style={{
              fontSize: 'clamp(1.25rem, 3vw, 1.875rem)',
              fontWeight: 700,
              color: 'white',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: '1.5rem'
            }}>
              Monthly Current Affairs <br /> Test Series
            </h3>
            
            <a 
              href="https://forms.gle/egUTLzDsCHad67of8" 
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#eab308',
                color: '#111827',
                fontWeight: 800,
                fontSize: 'clamp(1.125rem, 2vw, 1.25rem)',
                padding: '1rem 2.5rem',
                borderRadius: '9999px',
                boxShadow: '0 10px 15px -3px rgba(234, 179, 8, 0.3)',
                textDecoration: 'none',
                transition: 'all 0.3s',
                width: '100%',
                maxWidth: 'auto',
                marginBottom: '1rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#facc15';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#eab308';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <span>Enroll Now for FREE</span>
              <i className="fas fa-arrow-right" style={{ marginLeft: '0.75rem' }}></i>
            </a>
            <p style={{
              marginTop: '1rem',
              fontSize: '0.875rem',
              color: 'white'
            }}>
              Limited slots available. Join serious aspirants today.
            </p>
          </div>
        </div>
      </header>

      {/* Features / Value Prop */}
      <section style={{
        padding: '3rem 1rem',
        backgroundColor: 'rgba(31, 41, 55, 0.5)',
        backdropFilter: 'blur(4px)',
        borderTop: '1px solid rgba(55, 65, 81, 0.5)',
        position: 'relative',
        zIndex: 10
      }}>
        <div style={{
          maxWidth: '1280px',
          margin: '0 auto'
        }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
            fontWeight: 700,
            marginBottom: '3rem',
            color: 'white'
          }}>
            Why Join This Program?
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: isMobile ? '0.75rem' : '1rem',
            textAlign: 'center',
            justifyItems: 'stretch'
          }}>
            {[
              { icon: '💼', title: '100% Free', desc: 'Improve your prep without spending a single rupee.', color: '#f59e0b', bgColor: 'rgba(245, 158, 11, 0.15)' },
              { icon: '🎯', title: 'Exam Oriented', desc: 'High-yield topics for UPSC & State PSCs.', color: '#06b6d4', bgColor: 'rgba(6, 182, 212, 0.15)' },
              { icon: '📚', title: 'Structured Practice', desc: 'Stop reading randomly, start testing systematically.', color: '#10b981', bgColor: 'rgba(16, 185, 129, 0.15)' }
            ].map((feature, idx) => (
              <div 
                key={idx}
                style={{
                  padding: isMobile ? '1rem' : '1.5rem',
                  borderRadius: isMobile ? '0.75rem' : '1rem',
                  backgroundColor: feature.bgColor,
                  border: `2px solid ${feature.color}`,
                  transition: 'all 0.3s',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  cursor: 'pointer',
                  gridColumn: isMobile && idx === 2 ? '1 / -1' : 'auto',
                  justifySelf: isMobile && idx === 2 ? 'center' : 'stretch',
                  maxWidth: isMobile && idx === 2 ? '50%' : 'none'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = `0 8px 16px ${feature.color}40`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  width: isMobile ? '48px' : '64px',
                  height: isMobile ? '48px' : '64px',
                  backgroundColor: feature.color,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: isMobile ? '0.75rem' : '1rem',
                  fontSize: isMobile ? '1.25rem' : '1.5rem',
                  transition: 'all 0.3s',
                  color: 'white'
                }}>
                  {feature.icon}
                </div>
                <h3 style={{
                  fontSize: isMobile ? 'clamp(0.875rem, 2vw, 1rem)' : 'clamp(1rem, 2vw, 1.25rem)',
                  fontWeight: 700,
                  marginBottom: isMobile ? '0.375rem' : '0.5rem',
                  color: 'white'
                }}>
                  {feature.title}
                </h3>
                <p style={{
                  color: 'white',
                  fontSize: isMobile ? 'clamp(0.65rem, 1.5vw, 0.75rem)' : 'clamp(0.75rem, 1.5vw, 0.875rem)'
                }}>
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section style={{
        padding: isMobile ? '2rem 1rem' : '4rem 1.5rem',
        position: 'relative',
        zIndex: 10
      }}>
        <div style={{
          maxWidth: '896px',
          margin: '0 auto',
          backgroundColor: 'rgba(31, 41, 55, 0.8)',
          backdropFilter: 'blur(12px)',
          borderRadius: isMobile ? '1rem' : '1.5rem',
          padding: isMobile ? '1.25rem' : '2rem',
          border: '1px solid rgba(75, 85, 99, 0.5)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          position: 'relative',
          zIndex: 10
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem'
          }}>
            <div style={{ flex: 1 }}>
              <h3 style={{
                fontSize: isMobile ? 'clamp(1rem, 3vw, 1.125rem)' : 'clamp(1.25rem, 3vw, 1.5rem)',
                fontWeight: 700,
                marginBottom: isMobile ? '0.75rem' : '1rem',
                color: 'white',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}>
                Who Should Enroll?
              </h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {[
                  { text: <><strong style={{ color: 'white' }}>Beginners</strong> struggling to remember monthly current affairs.</> },
                  { text: <><strong style={{ color: 'white' }}>Working Professionals</strong> who need efficient, structured practice.</> },
                  { text: <><strong style={{ color: 'white' }}>Other Govt Exam Aspirants</strong> (State PSC, SSC, Banking) looking for quality GK practice.</> },
                  { text: 'Anyone unsure if their preparation is on the right track.' }
                ].map((item, idx) => (
                  <li key={idx} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: isMobile ? '0.75rem' : '1rem',
                    color: 'white',
                    fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.875rem)' : 'clamp(0.875rem, 2vw, 1rem)'
                  }}>
                    <span style={{ color: '#10b981', marginRight: isMobile ? '0.5rem' : '0.75rem', marginTop: isMobile ? '0.125rem' : '0.25rem', fontSize: isMobile ? '0.875rem' : '1rem' }}>✓</span>
                    <span style={{ color: 'white', fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.875rem)' : 'clamp(0.875rem, 2vw, 1rem)' }}>{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div style={{
              width: '100%',
              textAlign: 'center'
            }}>
              <div style={{
                backgroundColor: 'rgba(17, 24, 39, 0.8)',
                padding: isMobile ? '1rem' : '1.5rem',
                borderRadius: isMobile ? '0.75rem' : '1rem',
                border: '1px solid rgba(55, 65, 81, 0.5)'
              }}>
                <div style={{ fontSize: isMobile ? '1.75rem' : '2.5rem', marginBottom: isMobile ? '0.375rem' : '0.5rem' }}>📚✨</div>
                <p style={{
                  fontSize: isMobile ? 'clamp(0.7rem, 2vw, 0.8rem)' : '0.875rem',
                  color: 'white',
                  marginBottom: isMobile ? '0.75rem' : '1rem'
                }}>
                  "True learning should be accessible to all."
                </p>
                <span style={{
                  fontSize: isMobile ? 'clamp(0.625rem, 1.5vw, 0.7rem)' : '0.75rem',
                  fontWeight: 700,
                  color: 'white',
                  textTransform: 'uppercase'
                }}>
                  Adhva Academy Stands With You
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Features / What You Get */}
      <section style={{
        padding: isMobile ? '2rem 1rem' : '3rem 1rem',
        backgroundColor: 'rgba(17, 24, 39, 0.5)',
        backdropFilter: 'blur(4px)',
        borderTop: '1px solid rgba(31, 41, 55, 0.5)',
        position: 'relative',
        zIndex: 10
      }}>
        <div style={{
          maxWidth: '896px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: isMobile ? 'clamp(1.25rem, 4vw, 1.5rem)' : 'clamp(1.5rem, 3vw, 1.875rem)',
            fontWeight: 700,
            textAlign: 'center',
            marginBottom: isMobile ? '1.5rem' : '2.5rem',
            color: 'white'
          }}>
            Everything You Need to Excel
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)',
            gap: isMobile ? '0.75rem' : '1.5rem'
          }}>
            {[
              { icon: '📄', title: 'Detailed Synopsis', desc: "In-depth explanations to understand the 'Why' & 'How'.", color: '#f59e0b', bgColor: 'rgba(245, 158, 11, 0.15)' },
              { icon: '📈', title: 'Trend Analysis', desc: 'Questions based on latest UPSC PYQ trends.', color: '#06b6d4', bgColor: 'rgba(6, 182, 212, 0.15)' },
              { icon: '🏆', title: 'All India Ranking', desc: 'Know where you stand among serious aspirants.', color: '#10b981', bgColor: 'rgba(16, 185, 129, 0.15)' },
              { icon: '💾', title: 'Downloadable PDFs', desc: 'Access question papers and solutions anytime.', color: '#8b5cf6', bgColor: 'rgba(139, 92, 246, 0.15)' }
            ].map((feature, idx) => (
              <div 
                key={idx}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  padding: isMobile ? '0.75rem 0.5rem' : '1rem',
                  backgroundColor: feature.bgColor,
                  borderRadius: isMobile ? '0.375rem' : '0.5rem',
                  border: `2px solid ${feature.color}`,
                  height: '100%',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = `0 8px 16px ${feature.color}40`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  flexShrink: 0,
                  backgroundColor: feature.color,
                  padding: isMobile ? '0.5rem' : '0.75rem',
                  borderRadius: isMobile ? '0.375rem' : '0.5rem',
                  color: 'white',
                  marginBottom: isMobile ? '0.5rem' : '1rem',
                  fontSize: isMobile ? '1.125rem' : '1.5rem',
                  width: isMobile ? '40px' : '56px',
                  height: isMobile ? '40px' : '56px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {feature.icon}
                </div>
                <div>
                  <h4 style={{
                    fontSize: isMobile ? 'clamp(0.75rem, 2vw, 0.875rem)' : 'clamp(1rem, 2vw, 1.125rem)',
                    fontWeight: 700,
                    color: 'white',
                    marginBottom: isMobile ? '0.125rem' : '0.25rem'
                  }}>
                    {feature.title}
                  </h4>
                  <p style={{
                    color: 'white',
                    fontSize: isMobile ? 'clamp(0.625rem, 1.5vw, 0.7rem)' : 'clamp(0.75rem, 1.5vw, 0.875rem)',
                    marginTop: isMobile ? '0.125rem' : '0.25rem',
                    lineHeight: isMobile ? '1.3' : '1.5'
                  }}>
                    {feature.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section style={{
        padding: '4rem 1.5rem',
        backgroundColor: 'rgba(31, 41, 55, 0.5)',
        backdropFilter: 'blur(4px)',
        position: 'relative',
        zIndex: 10
      }}>
        <div style={{
          maxWidth: '768px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
            fontWeight: 700,
            textAlign: 'center',
            marginBottom: '2rem',
            color: 'white'
          }}>
            Frequently Asked Questions
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {[
              {
                question: 'Is this test series really 100% free?',
                answer: 'Yes! Adhva Academy is committed to supporting serious aspirants. There are no hidden charges for the Monthly Current Affairs Test Series.'
              },
              {
                question: 'How will I receive the tests?',
                answer: "Once you register, you will get exclusive access to our 'Learning Path' online platform. You can attempt tests in real-time exam mode, view instant analytics, and download detailed solutions directly from your dashboard."
              },
              {
                question: 'Is it helpful for working professionals?',
                answer: "Absolutely. The tests are designed to be concise yet comprehensive, allowing you to revise an entire month's current affairs efficiently over the weekend."
              }
            ].map((faq, idx) => (
              <div 
                key={idx}
                style={{
                  backgroundColor: 'rgba(17, 24, 39, 0.6)',
                  borderRadius: '0.5rem',
                  border: '1px solid rgba(55, 65, 81, 0.5)',
                  overflow: 'hidden'
                }}
              >
                <div 
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '1rem',
                    fontWeight: 500,
                    color: 'white',
                    transition: 'background-color 0.3s'
                  }}
                  onClick={() => toggleFaq(idx)}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(55, 65, 81, 0.5)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  <span>{faq.question}</span>
                  <span style={{
                    transition: 'transform 0.3s',
                    transform: openFaq === idx ? 'rotate(180deg)' : 'rotate(0deg)'
                  }}>
                    ▼
                  </span>
                </div>
                {openFaq === idx && (
                  <div style={{
                    padding: '1rem',
                    color: 'white',
                    borderTop: '1px solid rgba(55, 65, 81, 0.5)',
                    backgroundColor: 'rgba(17, 24, 39, 0.5)'
                  }}>
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      </div>

      {/* Final CTA Footer - No overlay */}
      <footer style={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        textAlign: 'center',
        padding: '3rem 1.5rem',
        borderTop: '1px solid rgba(31, 41, 55, 0.5)',
        position: 'relative',
        zIndex: 10
      }}>
        <h2 style={{
          fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
          fontWeight: 700,
          marginBottom: '2rem',
          color: 'white'
        }}>
          Ready to boost your score?
        </h2>
        
        <a 
          href="https://forms.gle/egUTLzDsCHad67of8" 
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem 2rem',
            fontWeight: 700,
            color: 'white',
            transition: 'all 0.2s',
            backgroundColor: '#2563eb',
            fontSize: '1.125rem',
            borderRadius: '9999px',
            textDecoration: 'none',
            boxShadow: '0 10px 15px -3px rgba(37, 99, 235, 0.5)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#1d4ed8';
            e.target.style.boxShadow = '0 10px 15px -3px rgba(37, 99, 235, 0.7)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#2563eb';
            e.target.style.boxShadow = '0 10px 15px -3px rgba(37, 99, 235, 0.5)';
          }}
        >
          <span>Click Here to Enroll Now</span>
          <i className="fas fa-external-link-alt" style={{ marginLeft: '0.5rem' }}></i>
        </a>

        <div style={{
          marginTop: '3rem',
          color: 'white',
          fontSize: '0.875rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <p style={{ marginBottom: '0.5rem', color: 'white' }}>Adhva Academy</p>
        </div>
      </footer>

      <Footer />
    </div>
  );
};

export default AdhvaMonthlyCurrentAffairsPage;
